import React, { useState, useEffect } from 'react';
import { Feedback } from '@mui/icons-material';
import { Box, Card, CardContent, Popper, Tooltip, Typography } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import moment from 'moment';

const Notificaciones = ({ avisos = [], triggerClassName = '' }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [mensajes, setMensajes] = useState([
        {
            title: 'Bienvenido a Universidad Maderas',
            desc: 'Recibe avisos sobre tus cursos activos y notificaciones de la plataforma'
        }
    ]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    useEffect(() => {
        if (!avisos.length) return;
        const hoy = moment();
        const avisosActual = avisos.filter((element) => {
            if (!element.date) return false;
            if (element.periodo === 'ANUAL') {
                const year = new Date().getFullYear();
                const arr = element.date.split('-');
                const inicio = moment(`${year}-${arr[1]}-${arr[2]}`);
                return inicio.isSame(hoy, 'day');
            } else {
                const inicio = moment(element.date);
                const diferencia = inicio.diff(hoy, 'days');
                if (element.fechaFin && element.fechaFin !== 'NO') {
                    const fin = moment(element.fechaFin);
                    return hoy.isBetween(inicio, fin, undefined, '[]');
                } else {
                    return diferencia >= 0 && diferencia <= 3;
                }
            }
        });
        setMensajes(avisosActual.length ? avisosActual : []);
    }, [avisos]);

    return (
        <>
            <Tooltip title="Mostrar notificaciones" placement="top">
                <button
                    className={triggerClassName}
                    aria-describedby={id}
                    onClick={handleClick}
                    aria-label="Mostrar notificaciones"
                    type="button"
                >
                    <Feedback fontSize="medium" />
                </button>
            </Tooltip>

            <Popper id={id} open={open} anchorEl={anchorEl} placement="right" sx={{ zIndex: 3 }}>
                <MainCard border={false} elevation={16} content={false} boxShadow>
                    <Box sx={{ p: 2, overflowY: 'scroll', maxHeight: '300px' }}>
                        {mensajes.length ? (
                            mensajes.map((av, index) => (
                                <Card key={`av${index}`} variant="outlined" sx={{ m: 1 }}>
                                    <CardContent>
                                        <Typography variant="body1">{av.title}</Typography>
                                        <Typography variant="body2">{av.desc}</Typography>
                                    </CardContent>
                                </Card>
                            ))
                        ) : (
                            <Typography variant="body2">No hay notificaciones recientes.</Typography>
                        )}
                    </Box>
                </MainCard>
            </Popper>
        </>
    );
};

export default Notificaciones;
